import React, { useRef, useEffect, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Player } from '@ifeng-fe/three_terminal/es/mobile/video';
// setH5PageTouchArea禁止客户端默认手势区域 / setNoSlideArea组合设置客户端禁止手势区域  setPageNoActiveListener页面无活动监听
import { setH5PageTouchArea, setNoSlideArea, setPageNoActiveListener } from '@src/public/utils/app';
// 判断ios设备
import { isIOS, inFlowIframeJump } from '@src/public/utils';
// png图片
import DefaulVideo from './defaultVideo.png';
import styles from './index.css';
import PropTypes from 'prop-types';
// 二次封装：端内跳转
import { linkBase, dispatchPage } from '../Link';
// 常量：嵌入热点专题的时间线
import { EVENT_LIST_INFLOW } from '@src/public/constants';

const TimeListVideo = ({
    videoConfig, // 视频信息
    playermsg, // 播放器信息
    showType, // 页面展示类型
    timeId, // 时间线id
}) => {
    // 视频数据源
    // const { url, poster, duration2 } = video;
    const { mobileUrl, bigPosterUrl, duration } = videoConfig;

    // 展示同层渲染视频
    const [showTongcengVideo, setShowTongcengVideo] = useState(false);

    // 同层渲染容器id
    const id = Math.random();

    // 随机视频uuid
    const uuid = Math.random();
    // 设置视频uuid
    const [videoUuid, setVideoUuid] = useState('');
    const currentVideoUuid = useRef(''); // 设置目标视频id(ios)
    const videoPlayingRef = useRef(false); // 当前视频播放中的判断(ios)

    const playerRef = useRef(); // 视频引用
    const videoApis = useRef(); // 视频控制功能
    const videoPosition = useRef(); // 视频位置

    // 切换同层视频组件销毁事件id
    const videoDestory = uuid => {
        setVideoUuid(uuid);
    };

    // 监听videoUuid => 展示同层渲染视频
    useEffect(
        () => {
            // id相同表示是当前组件的视频点击播放
            if (!videoDestory || (videoUuid && videoUuid === currentVideoUuid.current)) {
                setShowTongcengVideo(true);
            } else {
                // 其他组件的视频，应重置为初始图片状态展示
                setShowTongcengVideo(false);
            }
        },
        [videoUuid],
    );
    // 同层渲染播放器（ios）
    useEffect(
        () => {
            if (showTongcengVideo) {
                let index = 1;
                // 回调:创建播放器
                const callbackName = `callback_${index++}`;

                setTimeout(() => {
                    // 调用同层渲染原生视频播放器
                    // eslint-disable-next-line no-unused-expressions
                    window?.grounds?.openTongcengVideo &&
                        // 同层渲染原生视频播放器（接受三个参数url/JSON.stringify/callbackName）
                        window?.grounds?.openTongcengVideo(
                            mobileUrl, // 播放地址
                            JSON.stringify({
                                // 反序列化
                                // containerId: `videoBox-${id}`, // 原生浏览器的容器id
                                containerId: `videoBox-${id}`, // 原生浏览器的容器id
                                ad: {},
                                autoplay: false, // {boolean} 是否自动关播放 默认false
                                poster: bigPosterUrl || DefaulVideo, // {string} 视频缩略图
                                zt: '', // 专题id
                                dm: '', // 域名
                                lm: '', // 栏目
                                keywords: '', // 视频关键词
                                vid: '', // 视频唯一标识
                                position: 'relative',
                            }),
                            callbackName, // 通知web端触发事件
                        );
                    // 获取当前视频播放器
                    window[callbackName] = eventName => {
                        if (eventName === 'play' && !videoPlayingRef.current) {
                            console.log('playing :>> ', true);
                            videoPlayingRef.current = true;
                        }
                        if (['pause', 'end', 'error'].includes(eventName) && videoPlayingRef.current) {
                            console.log('playing :>> ', false);
                            videoPlayingRef.current = false;
                        }
                    };
                    // 调用端内api播放当前视频
                    // eslint-disable-next-line no-unused-expressions
                    window.grounds?.playVideo && window.grounds?.playVideo();

                    return;
                }, 30);
            }
        },
        [showTongcengVideo],
    );

    // 切换全屏=》暂停视频播放(ios)
    useEffect(() => {
        setPageNoActiveListener(() => {
            // eslint-disable-next-line no-unused-expressions
            videoApis.current?.pause();
        });
    }, []);

    // 判断播放器是否移除视口=>暂停播放器（ios）
    useEffect(() => {
        if (playerRef.current) {
            const io = new IntersectionObserver( // 接受两个参数[callback,option]
                ([entry]) => {
                    const { rootBounds, boundingClientRect, intersectionRatio } = entry;

                    if (intersectionRatio === 0 && videoPlayingRef.current === true) {
                        // 销毁视频
                        // eslint-disable-next-line no-unused-expressions
                        window?.grounds?.destoryVideo();
                        setShowTongcengVideo(false);
                    }
                },
                { root: null, threshold: 0, rootMargin: '-163px 0px -65px 0px' },
            );

            // 开始观察
            io.observe(playerRef.current);

            // 关闭观察器
            return () => {
                io.disconnect();
            };
        }
    }, []);

    // player视频播放器（端外/安卓）
    const mobileVideoData = {
        // 滑动组件配置
        config: {
            auth: true, // 防盗链，建议添加，如果guid未请求到数据会自动转为false
            showTitle: true, // 标题
            showPoster: true, // 封面
            showController: true, // 控制按钮
            m3u8Play: true,
            pauseAfterLeave: true, // 离开视口暂停
            singlePlay: true, // 单个播放
            isCircle: true,
            controlsList: 'nodownload',
            clickVideoStatisticsCB: () => {
                // console.log('首次点击播放器区域自定义统计上报，只触发一次');
            },
            firstFrameStatisticsCB: () => {
                // console.log('视频开始播放首帧自定义统计上报');
            },
            // 获取视频控制
            getExposeApisCb: apis => {
                videoApis.current = apis;
            },
            // 全屏触发
            fullscreenListener: isFull => {
                if (isIOS()) {
                    return;
                }
                if (isFull) {
                    videoPosition.current = document.documentElement.scrollTop || document.body.scrollTop;
                } else {
                    window.scroll(0, videoPosition.current);
                }
            },
        },

        videoinfo: {
            mobileUrl, // mobileUrl必须，如guid未请求到视频信息，将使用默认地址播放
            bigPosterUrl, // bigPosterUrl必须，如guid未请求到视频信息，将使用该bigPosterUrl作为缩略图
        },
    };

    return (
        <>
            {showType === EVENT_LIST_INFLOW && timeId ? (
                <div
                    className={styles.video_wrap}
                    onClick={() => {
                        // console.log('端内跳转');
                        const url = `${linkBase}/loc/timeline/event/${timeId}`;

                        if (window.grounds) {
                            dispatchPage({ to: url });
                        } else {
                            inFlowIframeJump(url);
                        }
                    }}>
                    <div className={styles.video_img_container}>
                        <img src={bigPosterUrl || DefaulVideo} />
                        <span className={styles.video_play_icon} />
                    </div>
                </div>
            ) : (
                mobileUrl &&
                // 端内ios
                (window?.grounds?.openTongcengVideo ? (
                    <div ref={playerRef} className={styles.video_wrap}>
                        {/* 第二次渲染  */}
                        {showTongcengVideo ? (
                            <div className={styles.video_container}>
                                <div className={styles.floatVideoBox} id={`videoBox-${id}`}>
                                    <div style={{ width: '101%', height: '101%' }} />
                                </div>
                                <img src={bigPosterUrl || DefaulVideo} />
                            </div>
                        ) : (
                            // 第一次渲染:改变showTongcengVideo，触发第二次渲染
                            <div
                                className={styles.video_img_container}
                                onClick={() => {
                                    try {
                                        if (window?.grounds?.openTongcengVideo) {
                                            // eslint-disable-next-line no-unused-expressions
                                            window?.grounds?.destoryVideo();
                                            // 获取目标视频
                                            currentVideoUuid.current = uuid;
                                            // 切换同层视频组件销毁事件id
                                            // eslint-disable-next-line no-unused-expressions
                                            videoDestory && videoDestory(uuid);

                                            window.playVideo = (eventType, playName) => {
                                                console.log(eventType, playName);
                                            };
                                        }
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }}>
                                <img src={bigPosterUrl || DefaulVideo} />
                                {!showTongcengVideo && <span className={styles.video_play_icon} />}
                            </div>
                        )}
                    </div>
                ) : (
                    // 端外/安卓环境
                    <div className={styles.video_wrap}>
                        <div className={styles.video_inner}>
                            <div
                                className={styles.video_content}
                                ref={playerRef}
                                onClick={() => {
                                    const { top, bottom } = playerRef.current?.getBoundingClientRect();

                                    setNoSlideArea([{ top, end: bottom, type: 'fixed' }]);
                                    setH5PageTouchArea(top, bottom, window.innerHeight);
                                }}>
                                <Player
                                    ref={playerRef}
                                    videoConfig={{ ...mobileVideoData.videoinfo, disableSendState: true }}
                                    playermsg={playermsg || { ...mobileVideoData.config }}
                                />
                            </div>
                        </div>
                    </div>
                ))
            )}
        </>
    );
};

TimeListVideo.propTypes = {
    /**
     * 视频信息
     */
    videoConfig: PropTypes.object,
    /**
     * 播放器配置
     */
    playermsg: PropTypes.object || undefined,
    showType: PropTypes.string,
    timeId: PropTypes.string,
};

export default errorBoundary(TimeListVideo);
